import { sample } from 'effector'

import { model as priceSettingsModel } from '~/entities/price-settings'

import { aye } from '~/shared/helpers'
import { postItemToCartFx, postTvLiveEventToCart } from './model'

// tv channel case
sample({
  clock: postTvLiveEventToCart,
  source: {
    selectedPriceSettings: priceSettingsModel.$selectedPriceSettings,
  },
  filter: ({ selectedPriceSettings }, clockData) =>
    aye(clockData) && aye(selectedPriceSettings),
  fn: ({ selectedPriceSettings }, clockData) => {
    return {
      originalPrice: selectedPriceSettings!.price,
      liveEvent: {
        liveEventId: clockData.liveEventId,
        pricingId: selectedPriceSettings!.priceSettingsId,
      },
    }
  },
  target: postItemToCartFx,
})
